module.exports = __webpack_public_path__ + "static/media/mindfulness-for-financial-stress@2x.bf33be3c.png";